import Vue from  'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
Vue.config.productionTip = false
import App from './App.vue';
import VueRouter from 'vue-router'
import AdministrarUsers from './components/AdministrarUsers.vue'
import LoginPage from './components/LoginPage.vue'
import DashboardTest from './components/DashboardTest.vue'
import PageInicial from './components/PageInicial.vue'
import Nosotros from './components/Nosotros.vue'
import Cursos from './components/Cursos.vue'
import BlogNotice from './components/BlogNotice.vue'
import ConTacto from './components/ConTacto.vue'
import '@mdi/font/css/materialdesignicons.css';
import Privacidad from './components/Privacidad.vue'
import AvisoLegal from './components/AvisoLegal.vue'
import HostingComparativa from './components/HostingComparativa.vue'
import SaaSHerramientas from './components/SaaSHerramientas.vue'
import Ciberseguridad from './components/Ciberseguridad.vue'
import SegurosTech from './components/SegurosTech.vue'
import ComparativasTech from './components/ComparativasTech.vue'
Vue.use(Vuetify);  // Asegúrate de que Vuetify esté registrado
Vue.use(VueRouter);

const routes = [
  {
    path: '/recursos/hosting',
    component: HostingComparativa,
  },
  {
    path: '/recursos/saas',
    component: SaaSHerramientas,
  },
  {
    path: '/recursos/ciberseguridad',
    component: Ciberseguridad,
  },
  {
    path: '/recursos/seguros-tech',
    component: SegurosTech,
  },
  {
    path: '/recursos/comparativas',
    component: ComparativasTech,
  },
   {
    path: '/privacidad',
    component: Privacidad,
  },
  {
    path: '/aviso-legal',
    component: AvisoLegal,
  },
   {
    path: '/contacto', // Ruta para la página de inicio (Login)
    component: ConTacto,
  },
  {
    path: '/blog', // Ruta para la página de inicio (Login)
    component: BlogNotice,
  },
  {
    path: '/cursos', // Ruta para la página de inicio (Login)
    component: Cursos,
  },
   {
    path: '/', // Ruta para la página de inicio (Login)
    component: PageInicial,
  },
  
  {
    path: '/nosotros', // Ruta para la página de inicio (Login)
    component: Nosotros,
  },
  {
    path: '/login', // Ruta para la página de inicio (Login)
    component: LoginPage,
  },
  {
    path: '/administrar', // Ruta para la página de inicio (Login)
    component: AdministrarUsers,
  },
  {
    path: '/dashboard', // Ruta para el Dashboard
    component: DashboardTest,
  },
];

// Crea una instancia de Vue Router
const router = new VueRouter({
  mode: 'history',
  routes,
  
  scrollBehavior(to, from, savedPosition) {
    // Mantiene la posición si se usa back/forward, sino va al top
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },

});

new Vue({
  vuetify: new Vuetify(),
  router, // Añadir el router a la instancia de Vue
    render: h => h(App),
}).$mount('#app')